import React from 'react';
import './ProctorLogos.css';

const ProctorLogos = () => {
  const logos = [
    { src: '/images/comps/ATI.webp', alt: 'ATI' },
    { src: '/images/comps/Digi_Exam.webp', alt: 'DigiExam' },
    { src: '/images/comps/ETS.webp', alt: 'ETS' },
    { src: '/images/comps/Examity.webp', alt: 'Examity' },
    { src: '/images/comps/Examplify.webp', alt: 'Examplify' },
    { src: '/images/comps/Honorlock.webp', alt: 'Honorlock' },
    { src: '/images/comps/Mettl.webp', alt: 'Mettl' },
    { src: '/images/comps/ProctorU.webp', alt: 'ProctorU' },
    { src: '/images/comps/Proctorio.webp', alt: 'Proctorio' },
    { src: '/images/comps/Proctortrack.webp', alt: 'ProctorTrack' },
    { src: '/images/comps/Respondus.webp', alt: 'Respondus' },
    { src: '/images/comps/Prometric_ProProctor.webp', alt: 'Prometric', large: true  },
    { src: '/images/comps/Accuplacer.webp', alt: 'Accuplacer' },
    { src: '/images/comps/SafeExamBrowser.webp', alt: 'Safe Exam Browser', large: true  },
    { src: '/images/comps/AMPP-logo.webp', alt: 'AMPP' },
    { src: '/images/comps/Exam.net-logga.webp', alt: 'Exam.net', large: true },
    { src: '/images/comps/c8.webp', alt: 'C8' },
    { src: '/images/comps/img.webp', alt: 'Proctor' },
    { src: '/images/comps/logo-outline.svg', alt: 'ProProctor', large: true  },
    { src: '/images/comps/examsoft-color.svg', alt: 'ExamSoft' },
    { src: '/images/comps/689dc2dd8b97476db769b82e_Logo-website 1.svg', alt: 'Logo' },
    { src: '/images/comps/ged-logo.svg', alt: 'GED' },
    { src: '/images/comps/original.webp', alt: 'Original' },
    { src: '/images/comps/Logo-PSI-colored.svg', alt: 'PSI' },
    { src: '/images/comps/so.svg', alt: 'SO' },
  ];

  return (
    <section className="proctor-logos-section">
      <div className="logos-container">
        <div className="logos-grid">
          {logos.map((logo, index) => (
            <div 
              key={index}
              className={`logo-wrapper ${logo.large ? 'logo-large' : ''}`}
              style={{animationDelay: `${index * 0.03}s`}}
            >
              <img 
                src={logo.src} 
                alt={logo.alt}
                loading="lazy"
                className="logo-item"
              />
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ProctorLogos;
